import { render } from "./Anba Antonius church.vue?vue&type=template&id=2997079a&scoped=true"
const script = {}

import "./Anba Antonius church.vue?vue&type=style&index=0&id=2997079a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2997079a"

export default script